// Espelho JS de themis/lib/cnpjs_icaro.py — fonte canônica dos CNPJs do grupo.
// DVs validados via algoritmo oficial RF + confirmação Rubens (SAO=0002-70).

export const ICARO_CNPJS = {
  '06225952000190': { filial: 'JOI', cidade: 'Joinville',       uf: 'SC', status: 'ativa',          matriz: true  },
  '06225952000270': { filial: 'SAO', cidade: 'São Paulo',       uf: 'SP', status: 'ativa',          matriz: false },
  '06225952000351': { filial: 'FLN', cidade: 'Florianópolis',   uf: 'SC', status: 'ativa',          matriz: false },
  '06225952000432': { filial: 'CWB', cidade: 'Curitiba',        uf: 'PR', status: 'ativa',          matriz: false },
  '06225952000513': { filial: 'RIO', cidade: 'Duque de Caxias', uf: 'RJ', status: 'ativa',          matriz: false },
  '06225952000602': { filial: 'POA', cidade: 'Porto Alegre',    uf: 'RS', status: 'ativa',          matriz: false },
  '06225952000785': { filial: 'CPQ', cidade: 'Campinas',        uf: 'SP', status: 'ativa',          matriz: false },
  '06225952000866': { filial: 'BHZ', cidade: 'Belo Horizonte',  uf: 'MG', status: 'desenvolvimento', matriz: false },
  '06225952000947': { filial: 'EMB', cidade: 'Embu das Artes',  uf: 'SP', status: 'desenvolvimento', matriz: false },
  '06225952001080': { filial: 'ITJ', cidade: 'Itajaí',          uf: 'SC', status: 'desenvolvimento', matriz: false },
  '06225952001161': { filial: 'VIX', cidade: 'Vitória',         uf: 'ES', status: 'desenvolvimento', matriz: false },
};

export function filialDe(cnpj) {
  const clean = String(cnpj || '').replace(/\D/g, '');
  return ICARO_CNPJS[clean]?.filial || null;
}

export function formatarCnpj(cnpj) {
  const c = String(cnpj || '').replace(/\D/g, '');
  if (c.length !== 14) return cnpj;
  return `${c.slice(0,2)}.${c.slice(2,5)}.${c.slice(5,8)}/${c.slice(8,12)}-${c.slice(12)}`;
}

// Lista de filiais para selects (ordenada: matriz primeiro, depois ativas, depois em desenvolvimento)
export const FILIAIS_OPTIONS = Object.entries(ICARO_CNPJS)
  .map(([cnpj, info]) => ({ cnpj, ...info }))
  .sort((a, b) => {
    if (a.matriz !== b.matriz) return a.matriz ? -1 : 1;
    if (a.status !== b.status) return a.status === 'ativa' ? -1 : 1;
    return a.filial.localeCompare(b.filial);
  });
